import DocketContent from './components/DocketContent';
import DocketHeader from './components/DocketHeader';
import { Fragment } from 'react/jsx-runtime';
import { AppHeaderPortal, FlexContainer } from '@act/storybook';

const DocketPage = () => {
  return (
    <Fragment>
      <AppHeaderPortal>
        <DocketHeader />
      </AppHeaderPortal>
      <FlexContainer
        direction="column"
        height="100%"
        width="100%"
        sx={{
          maxWidth: '100%',
          overflowX: 'hidden',
          boxSizing: 'border-box',
        }}
      >
        <DocketContent />
      </FlexContainer>
    </Fragment>
  );
};

export default DocketPage;
